// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"06b533a1","292":"48e73759","484":"9a83b392","551":"0c1d3ebb","842":"41abdc5b"}[chunkId] + ".chunk.js";
};